import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { roleLabel } from "./labels";
import s from "./Reviewer.module.css";

export function VagaDetail() {
  const { role = "" } = useParams();
  const nav = useNavigate();
  const [testes, setTestes] = useState<any[]>([]);
  const [counts, setCounts] = useState<Record<string, { total: number; corrigidos: number }>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data: assessments } = await supabase
        .from("rec_assessments").select("id, slug, title, role, version, is_published, created_at")
        .eq("role", role).order("created_at");
      const ids = (assessments || []).map((a) => a.id);
      const { data: pipe } = ids.length
        ? await supabase.from("rec_v_pipeline").select("assessment_id, status").in("assessment_id", ids)
        : { data: [] as any[] };
      const c: Record<string, { total: number; corrigidos: number }> = {};
      for (const a of assessments || []) c[a.id] = { total: 0, corrigidos: 0 };
      for (const p of pipe || []) {
        if (!c[p.assessment_id]) continue;
        c[p.assessment_id].total++;
        if (p.status === "graded" || p.status === "reviewed") c[p.assessment_id].corrigidos++;
      }
      setTestes(assessments || []); setCounts(c); setLoading(false);
    })();
  }, [role]);

  return (
    <div className={s.page}>
      <div className={s.crumb}><a onClick={() => nav("/admin")}>Vagas</a> <span>/</span> <span>{roleLabel(role)}</span></div>
      <div className={s.h}>
        <h2>{roleLabel(role)}</h2>
        <button className="btn btn-ghost" onClick={() => nav("/admin/convites")}>Convidar candidato</button>
      </div>
      <h3>Testes desta vaga</h3>
      {loading ? <p className="muted">Carregando…</p> : testes.length === 0 ? <div className={s.empty}>Nenhum teste criado nesta vaga.</div> : (
        <div>
          {testes.map((t) => (
            <div key={t.id} className={s.testerow} onClick={() => nav(`/admin/teste/${t.id}`)} role="button" tabIndex={0}>
              <div className="tinfo">
                <h3>{t.title}</h3>
                <div className="dim" style={{ fontSize: 12, marginTop: 4 }}>
                  v{t.version} · {t.is_published ? <span className="badge badge-success">publicado</span> : <span className="badge badge-warning">rascunho</span>}
                </div>
              </div>
              <div className={s.tmeta}>
                <div style={{ textAlign: "right" }}><b>{counts[t.id]?.total ?? 0}</b><div className="dim" style={{ fontSize: 11 }}>candidatos</div></div>
                <div style={{ textAlign: "right" }}><b>{counts[t.id]?.corrigidos ?? 0}</b><div className="dim" style={{ fontSize: 11 }}>corrigidos</div></div>
                <span className="dim">›</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
